import { render, staticRenderFns } from "./IndexManageItem.vue?vue&type=template&id=40d099ba&scoped=true"
import script from "./IndexManageItem.vue?vue&type=script&lang=js"
export * from "./IndexManageItem.vue?vue&type=script&lang=js"
import style0 from "./IndexManageItem.vue?vue&type=style&index=0&id=40d099ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d099ba",
  null
  
)

export default component.exports